/**
 * Переключатель Turbo режима — неоморфный стиль
 */

import * as PIXI from 'pixi.js';
import { TextStyle } from 'pixi.js';

const WIDTH = 120;
const HEIGHT = 44;
const RADIUS = 10;
const INNER_OFFSET = 3;
const INNER_RADIUS = RADIUS - 1;
const INDICATOR_RADIUS = 6;
const INDICATOR_X = WIDTH - 24;

const BG_OUTER = 0x323232;
const BG_INNER = 0x666666;
const INDICATOR_OFF = 0xff0000;
const INDICATOR_ON = 0x00ff00;

export class TurboToggle extends PIXI.Container {
  private background: PIXI.Graphics;
  private innerBg: PIXI.Graphics;
  private label: PIXI.Text;
  private indicator: PIXI.Graphics;
  private indicatorGlow: PIXI.Graphics;
  private enabled = true;
  private active = false;
  private widthPx = WIDTH;
  private heightPx = HEIGHT;
  private onToggleCallback?: (active: boolean) => void;

  constructor() {
    super();
    this.background = new PIXI.Graphics();
    this.addChild(this.background);

    this.innerBg = new PIXI.Graphics();
    this.addChild(this.innerBg);

    this.label = new PIXI.Text('TURBO', new TextStyle({
      fontFamily: '"Jost"',
      fontSize: 15,
      fill: 0xb0b0b0,
      fontWeight: 'bold',
    }));
    this.label.anchor.set(0.5);
    this.label.x = 38;
    this.label.y = HEIGHT / 2;
    this.addChild(this.label);

    this.indicatorGlow = new PIXI.Graphics();
    this.addChild(this.indicatorGlow);

    this.indicator = new PIXI.Graphics();
    this.addChild(this.indicator);

    this.draw();
    this.setupInteractivity();
  }

  private setupInteractivity(): void {
    this.eventMode = 'static';
    this.cursor = 'pointer';
    this.hitArea = new PIXI.Rectangle(0, 0, WIDTH, HEIGHT);
    this.on('pointerdown', () => {
      if (!this.enabled) return;
      this.setActive(!this.active);
      this.onToggleCallback?.(this.active);
    });
  }

  private draw(): void {
    const g = this.background;
    g.clear();
    g.beginFill(BG_OUTER);
    g.drawRoundedRect(0, 0, WIDTH, HEIGHT, RADIUS);
    g.endFill();

    this.innerBg.clear();
    this.innerBg.beginFill(BG_INNER);
    this.innerBg.drawRoundedRect(INNER_OFFSET, INNER_OFFSET, WIDTH - INNER_OFFSET * 2, HEIGHT - INNER_OFFSET * 2, INNER_RADIUS);
    this.innerBg.endFill();

    this.label.text = 'TURBO';
    this.label.style.fill = this.active ? 0xe8e8e8 : 0xb0b0b0;

    const cy = HEIGHT / 2;
    const color = this.active ? INDICATOR_ON : INDICATOR_OFF;

    this.indicatorGlow.clear();
    this.indicatorGlow.beginFill(color, 0.35);
    this.indicatorGlow.drawCircle(INDICATOR_X, cy, INDICATOR_RADIUS + 4);
    this.indicatorGlow.endFill();

    this.indicator.clear();
    this.indicator.beginFill(color);
    this.indicator.drawCircle(INDICATOR_X, cy, INDICATOR_RADIUS);
    this.indicator.endFill();
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    this.eventMode = enabled ? 'static' : 'auto';
    this.cursor = enabled ? 'pointer' : 'default';
    this.alpha = enabled ? 1 : 0.5;
  }

  setActive(active: boolean): void {
    this.active = active;
    this.draw();
  }

  isActive(): boolean {
    return this.active;
  }

  setOnToggle(callback: (active: boolean) => void): void {
    this.onToggleCallback = callback;
  }

  get width(): number {
    return this.widthPx;
  }

  get height(): number {
    return this.heightPx;
  }
}
